//  App.js
//
//  Updated 1/25.
//
//  Abstract: App.js is the hub of the application - handles page routing.

import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from './components/Login/Login.js';
import Register from './components/Register/Register.js';
import About from './components/About/About.js';
import Support from './components/Support/Support.js';
import Dashboard from './components/Dashboard/Dashboard.js';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import theme from './services/themes/theme.js';



import { SessionProvider } from './context/SessionContext.js';
import Forgot from './components/Forgot/Forgot.js';
import NotFound from './components/NotFound/NotFound.js';

export default function App() {
  return (
    <>
      <MuiThemeProvider theme={theme}>
        <div>
          <Router>
            <div>
              <Switch>
                <Route exact path="/login">
                  <Login />
                </Route>
                <Route exact path="/forgot">
                  <Forgot />
                </Route>
                <Route exact path="/register">
                  <Register />
                </Route>
                <Route exact path="/about">
                  <About />
                </Route>
                <Route exact path="/support">
                  <Support />
                </Route>
                <Route path="/">
                  <SessionProvider>
                    <Dashboard />
                  </SessionProvider>
                </Route>
                <Route>
                  <NotFound />
                </Route>
              </Switch>
            </div>
          </Router>
        </div>
      </MuiThemeProvider>
    </>
  );
}